// extracted by mini-css-extract-plugin
export var section = "_2c-1";
export var topNav = "_2c-0";